import { Fragment, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createPrescriptionTemplate } from '../../../../../store/actions/prescriptionPad';
import CreateTemplateComp from '../../finishScreen/CreateTemplateDialog';
import UseTemplateDialog from '../UseTemplateDialog';
import { Kind } from '../../../../../store/types/prescription';
import PxToolKeyOptions from './PxToolKeyOptions';
import { ALL_KINDS } from '../../../../../utils/enums';

const TemplateIcons: React.FC<{
    pxToolKey: keyof Kind;
    save?: boolean;
    showTemplateIcon?: boolean;
    isV2?: boolean;
    isModal: boolean;
    withPeak: boolean;
    isCancelActive?: boolean;
    isForPackages?: boolean;
}> = ({
    pxToolKey,
    save = true,
    showTemplateIcon = true,
    isV2 = true,
    isModal,
    withPeak,
    isCancelActive = true,
    isForPackages,
}) => {
    const [saveAsTemplateVisible, setSaveAsTemplateVisible] = useState(false);
    const [templateSelectorVisible, setTemplateSelectorVisible] = useState(false);
    const prescriptionPadSelectorFunc = PxToolKeyOptions[pxToolKey].selectorFunc;
    const prescriptionPadStateData = useSelector(prescriptionPadSelectorFunc);
    const dispatch = useDispatch();

    const onSaveTemplate = (name: string, id?: string) => {
        dispatch(createPrescriptionTemplate(pxToolKey, name, id));
        setSaveAsTemplateVisible(false);
        return;
    };

    return (
        <Fragment>
            <div className="flex items-center space-x-16">
                {save &&
                    (prescriptionPadStateData.length === 0 ? (
                        <div
                            className={`flex items-center justify-center w-24 h-24 ${
                                isV2 ? 'bg-neutral-9' : 'bg-white'
                            } rounded-full min-w-24 min-h-24 cursor-pointer`}
                        >
                            {' '}
                            <Tooltip
                                placement="left"
                                overlayInnerStyle={{
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '4px 8px',
                                    backgroundColor: 'rgba(57, 68, 82, 1)',
                                    color: 'white',
                                }}
                                title={
                                    <span className="font-lato font-700 text-white">
                                        Select Some {PxToolKeyOptions[pxToolKey].tooltipText} to
                                        Save
                                    </span>
                                }
                            >
                                <svg
                                    className="w-14 h-14 fill-neutral-3"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                    <path d="M224 256c-35.2 0-64 28.8-64 64c0 35.2 28.8 64 64 64c35.2 0 64-28.8 64-64C288 284.8 259.2 256 224 256zM433.1 129.1l-83.9-83.9C341.1 37.06 328.8 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 151.2 442.9 138.9 433.1 129.1zM128 80h144V160H128V80zM400 416c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16V96c0-8.838 7.164-16 16-16h16v104c0 13.25 10.75 24 24 24h192C309.3 208 320 197.3 320 184V83.88l78.25 78.25C399.4 163.2 400 164.8 400 166.3V416z"></path>
                                </svg>
                            </Tooltip>
                        </div>
                    ) : (
                        <div className="relative">
                            <div
                                onClick={() => setSaveAsTemplateVisible(true)}
                                className={`relative flex items-center justify-center w-24 h-24 ${
                                    isV2 ? 'bg-neutral-9' : 'bg-white'
                                } rounded-full min-w-24 min-h-24 cursor-pointer`}
                            >
                                <svg
                                    className="w-14 h-14 fill-neutral-3"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                    <path d="M224 256c-35.2 0-64 28.8-64 64c0 35.2 28.8 64 64 64c35.2 0 64-28.8 64-64C288 284.8 259.2 256 224 256zM433.1 129.1l-83.9-83.9C341.1 37.06 328.8 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 151.2 442.9 138.9 433.1 129.1zM128 80h144V160H128V80zM400 416c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16V96c0-8.838 7.164-16 16-16h16v104c0 13.25 10.75 24 24 24h192C309.3 208 320 197.3 320 184V83.88l78.25 78.25C399.4 163.2 400 164.8 400 166.3V416z"></path>
                                </svg>
                            </div>
                            {saveAsTemplateVisible && (
                                <CreateTemplateComp
                                    key="create-template"
                                    // TODO add proper types
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    kind={ALL_KINDS[PxToolKeyOptions[pxToolKey].kind]}
                                    onCancel={() => setSaveAsTemplateVisible(false)}
                                    isModal={isModal}
                                    withPeak={withPeak}
                                    onSave={onSaveTemplate}
                                    isCancelActive={isCancelActive}
                                />
                            )}
                        </div>
                    ))}
                {showTemplateIcon && (
                    <div className="relative">
                        <div
                            onClick={() => setTemplateSelectorVisible(true)}
                            className="relative flex items-center justify-center w-24 h-24 bg-neutral-9 rounded-full min-w-24 min-h-24 cursor-pointer"
                        >
                            <svg
                                className={`w-14 h-14 ${PxToolKeyOptions[pxToolKey].showTemplateIconFillColor}`}
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path d="M448 64.01v64c0 17.69-14.31 32-32 32s-32-14.31-32-32v-32h-128v320h48c17.69 0 32 14.31 32 32s-14.31 31.1-32 31.1h-160c-17.69 0-32-14.31-32-31.1s14.31-32 32-32H192v-320H64v32c0 17.69-14.31 32-32 32s-32-14.31-32-32v-64c0-17.69 14.31-32 32-32h384C433.7 32.01 448 46.33 448 64.01z"></path>
                            </svg>
                            <p
                                className={`absolute select-none -bottom-2 ${PxToolKeyOptions[pxToolKey].showTemplateIconTextColor} left-16 text-12 font-700`}
                            >
                                {PxToolKeyOptions[pxToolKey].showTemplateIconText}
                            </p>
                        </div>

                        {templateSelectorVisible && (
                            <UseTemplateDialog
                                key="use-template"
                                close={() => setTemplateSelectorVisible(false)}
                                isV2={true}
                                // TODO add proper tyoes
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore/*  */
                                kind={ALL_KINDS[PxToolKeyOptions[pxToolKey].kind]}
                                isModal={isModal}
                                withPeak={withPeak}
                                isForPackages={isForPackages}
                            />
                        )}
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default TemplateIcons;
